import React from 'react';
import AlertDialog from 'components/AlertDialog';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { Disclosure } from 'further-ui/hooks';
import Spacing from 'components/Spacing';

interface Props {
  disclosure: Disclosure;
  onConfirmAddOrganisation: () => void;
  allowedDomains: Array<string>;
  submitting: boolean;
}

const AddOrganisationConfirmationDialog: React.FC<Props> = ({
  disclosure,
  onConfirmAddOrganisation,
  allowedDomains,
  submitting,
}) => {
  const message =
    allowedDomains.length > 1
      ? 'The selected user email does not match the permitted domains for this organisation. The permitted domains are: '
      : 'The selected user email does not match the permitted domain for this organisation. The permitted domain is: ';

  return (
    <AlertDialog
      open={disclosure.isOpen}
      onClose={disclosure.onClose}
      title="User email incorrect"
      content={
        <>
          <Spacing>
            <p>
              {message}
              {allowedDomains.map((domain, index, array) => (
                <strong key={domain}>
                  {domain}
                  {index < array.length - 1 && ', '}
                </strong>
              ))}
              .
            </p>
            <p>
              If you proceed, the user will not be added. You can add users at
              any time after the organisation is added.
            </p>
          </Spacing>
        </>
      }
      btnLabels={{
        cancel: 'Go back',
        confirm: 'Proceed',
      }}
      confirmBtnComponent={
        <>
          {submitting && <CircularProgress size={20} />}
          <Button
            variant="contained"
            color="primary"
            disabled={submitting}
            type="button"
            name="proceed"
            onClick={onConfirmAddOrganisation}
          >
            Proceed
          </Button>
        </>
      }
    />
  );
};

export default AddOrganisationConfirmationDialog;
